import { createRoutine } from 'redux-saga-routines';
import { SUBMIT_TRANSACTION_PAYMENT_CONFIRMATION } from 'types/transactions';
export const submitTransactionPaymentConfirmationRoutine = createRoutine(SUBMIT_TRANSACTION_PAYMENT_CONFIRMATION);
